import { Link } from "react-router-dom";
import { Scissors, Lock } from "lucide-react";

export default function Header() {
  const links = [
    { name: "Catalogo Macchine", target: "#catalogo", testid: "nav-link-catalog" },
    { name: "Servizi & Assistenza", target: "#servizi", testid: "nav-link-services" },
    { name: "Chi Siamo", target: "#chisiamo", testid: "nav-link-about" },
    { name: "Contatti", target: "#contatti", testid: "nav-link-contact" },
  ];
  return (
    <header className="bg-white/80 backdrop-blur-xl border-b border-sky-100 shadow-sm z-50 sticky top-0" data-testid="main-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <a href="#" className="flex items-center gap-3" data-testid="brand-logo">
          <img src="/logo.jpg" alt="Morselli Renzo - Macchine da Cucire" className="h-10 w-auto" />
          <span className="leading-tight border-l border-slate-200 pl-3 hidden sm:block">
            <span className="block text-[10px] uppercase tracking-[0.18em] text-sky-700">Macchine da Cucire dal 1938</span>
          </span>
        </a>
        <nav className="hidden md:flex items-center gap-7">
          {links.map((l) => (
            <a key={l.testid} href={l.target} data-testid={l.testid}
              className="text-sm font-medium text-slate-600 hover:text-sky-700 transition-colors duration-200">
              {l.name}
            </a>
          ))}
        </nav>
        <Link to="/admin" data-testid="nav-admin-login-button"
          className="flex items-center gap-1.5 text-xs font-medium text-slate-400 hover:text-sky-700 border border-slate-200 hover:border-sky-300 rounded-full px-3 py-1.5 transition-colors duration-200">
          <Lock className="w-3 h-3" />
          Area Riservata
        </Link>
      </div>
    </header>
  );
}
